import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-minus-dark',
  templateUrl: './icon-minus-dark.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconMinusDarkComponent {}
